import { IMAGES_ASSETS_URL } from '../constants/links';
import { CreditCardBrands } from '../constants/credit-card';
import { hasProjectLOCEnrolledInT2C, hasShopLOCEnrolledInT2C, } from './pro-house-account';
import { T2CStatus } from '../constants/payments';
const getImagePath = (path) => `${IMAGES_ASSETS_URL}${path}`;
export const getCardImagePath = (cardBrand, cardType) => {
    switch (cardBrand) {
        case CreditCardBrands.VISA:
            return getImagePath('/credit-card-visa.png');
        case CreditCardBrands.MA:
            return getImagePath('/credit-card-mastercard.png');
        case CreditCardBrands.AMEX:
            return getImagePath('/credit-card-amex.png');
        case CreditCardBrands.DISC:
            return getImagePath('/credit-card-discover.png');
        case CreditCardBrands.HDCOM:
            return cardType === 'HR'
                ? getImagePath('/credit-card-commercial-revolving.png')
                : getImagePath('/credit-card-prox.png');
        case CreditCardBrands.HDCON:
            return getImagePath('/credit-card-hd-consumer.png');
        case CreditCardBrands.PROP:
            return getImagePath('/credit-card-pro-purchase.png');
        case CreditCardBrands.PROX:
            return getImagePath('/credit-card-prox.png');
        default:
            return '';
    }
};
const showPTCAnalyticsDescription = (locType, t2cPrimary) => {
    if (locType === 'PROJECT') {
        return 'pro house project';
    }
    return t2cPrimary ? 'pro house shop primary' : 'pro house shop secondary';
};
export const getAnalyticsCardBrand = (cardBrand, cardType, locType, t2cPrimary) => {
    const brandMapping = {
        [CreditCardBrands.VISA]: 'visa',
        [CreditCardBrands.MA]: 'mc',
        [CreditCardBrands.AMEX]: 'amex',
        [CreditCardBrands.DISC]: 'disc',
        [CreditCardBrands.HDCON]: 'consumer',
        [CreditCardBrands.HDCOM]: cardType === 'HR' ? 'hdcomrev' : 'hdcom',
        [CreditCardBrands.PROP]: locType
            ? showPTCAnalyticsDescription(locType, t2cPrimary || false)
            : 'unknown',
        [CreditCardBrands.PROX]: 'prox',
        [CreditCardBrands.HDMC]: '',
        [CreditCardBrands.HA]: '',
    };
    return cardBrand ? brandMapping[cardBrand] : '';
};
export const shouldShowCcT2CUnenrollConfirmModal = ({ selectedCard, creditCards, linesOfCredit, }) => {
    const { t2cPrimary: selectedCardIsPrimaryT2C } = selectedCard;
    if (!selectedCardIsPrimaryT2C) {
        return false;
    }
    const hasProjLOCEnrolledInT2C = hasProjectLOCEnrolledInT2C(linesOfCredit);
    if (!hasProjLOCEnrolledInT2C) {
        return false;
    }
    const hasShopLoc = hasShopLOCEnrolledInT2C(linesOfCredit);
    if (hasShopLoc) {
        return false;
    }
    const hasOtherCcEnrolledInT2C = hasCcEnrolledInT2C(creditCards.filter((card) => card.paymentId !== selectedCard.paymentId));
    return !hasOtherCcEnrolledInT2C;
};
export const hasCcEnrolledInT2C = (paymentCards) => {
    return paymentCards.some((card) => card.t2cStatus === T2CStatus.PENDING ||
        card.t2cStatus === T2CStatus.ENROLLED);
};
